import styled from 'styled-components';

import {
  spaceL,
  spaceXL,
  spaceXXL,
  xdlColorBackgroundSecondary,
  xdlColorTextSecondary,
} from '@xing-com/tokens';
import {
  BodyCopy as InnerBodyCopy,
  Headline as InnerHeadline,
} from '@xing-com/typography';

import InnerBaseButton from '../../components/base-button';

export const EmptyStateCard = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: ${spaceXXL} 0 ${spaceXXL} 0;
  background-color: ${xdlColorBackgroundSecondary};
  height: 240px;
  @media (min-width: 740px) {
    height: 300px;
  }
`;

export const TextLayer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spaceXXL} ${spaceXL};
`;

export const Headline = styled(InnerHeadline)`
  color: ${xdlColorTextSecondary};
  margin-right: ${spaceL};
`;

export const BodyCopy = styled(InnerBodyCopy)`
  color: ${xdlColorTextSecondary};
  margin-right: ${spaceL};
`;

export const BaseButton = styled(InnerBaseButton)`
  padding: ${spaceL};
`;

export const Image = styled.img`
  display: none;
  @media (min-width: 740px) {
    display: flex;
  }
`;
